import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import React from "react";

function ConfirmDialog({ open, message, onConfirm, onCancel, confirmText, closeText, btnConfirm, title }) {
    const _btnConfirm = btnConfirm ? (
        btnConfirm
    ) : (
        <Button
            onClick={() => {
                onConfirm();
            }}
            color="secondary"
        >
            {confirmText || "Ok"}
        </Button>
    );

    const _title = title ? title : "Confirmation Required";

    return (
        <Dialog
            open={open}
            fullWidth={true}
            maxWidth={"sm"}
            onClose={onCancel}
            aria-labelledby="responsive-dialog-title"
        >
            <DialogTitle id="responsive-dialog-title">{_title}</DialogTitle>
            <DialogContent>
                <DialogContentText>{message}</DialogContentText>
            </DialogContent>
            <DialogActions>
                {_btnConfirm}
                <Button
                    onClick={() => {
                        onCancel();
                    }}
                >
                    {closeText || "Close"}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
export default ConfirmDialog;
